import React, { useState } from 'react';
import { DropdownMenu, Search } from '@spark';
import { getUniqueProjectNames, getUniqueUsers } from './trainingsUtils';
import StatusFilter from './StatusFilter';
import UserFilterSelect from '@/shared/components/UserFilterSelect';
import TaskTypeFilter from '@/features/tasks/components/TaskTypeFilter';
import './TrainingsFilterBar.css';

const TrainingsFilterBar = ({
    trainings,
    searchTerm,
    projectFilter,
    statusFilter,
    userFilter,
    taskTypeFilter,
    onSearchChange,
    onProjectFilterChange,
    onStatusFilterChange,
    onUserFilterChange,
    onTaskTypeFilterChange
}) => {
    const projectNames = getUniqueProjectNames(trainings);
    const users = getUniqueUsers(trainings);
    const [projectOpen, setProjectOpen] = useState(false);

    const handleStatusReset = () => {
        onStatusFilterChange([]);
    };

    const handleStatusApply = (selectedStatuses) => {
        onStatusFilterChange(selectedStatuses);
    };

    const isDefaultProject = !projectFilter || projectFilter === 'All Projects';

    const projectItems = [
        {
            label: 'All Projects',
            state: isDefaultProject ? 'selected' : 'default',
            onClick: () => {
                onProjectFilterChange('All Projects');
                setProjectOpen(false);
            },
        },
        ...projectNames.map(name => ({
            label: name,
            state: projectFilter === name ? 'selected' : 'default',
            onClick: () => {
                onProjectFilterChange(name);
                setProjectOpen(false);
            },
        })),
    ];

    return (
        <div className="trainings-filter-bar">
            <div className="filter-controls">
                <div className="trainings-filter-dropdown-item">
                    <DropdownMenu
                        selectType="single-select"
                        showLabel={false}
                        size="medium"
                        placeholder="All Projects"
                        text={isDefaultProject ? undefined : projectFilter}
                        panelLayout="overlay"
                        open={projectOpen}
                        onOpenChange={setProjectOpen}
                        items={projectItems}
                    />
                </div>

                <TaskTypeFilter
                    value={taskTypeFilter}
                    onChange={onTaskTypeFilterChange}
                    placeholder="All Task Types"
                    className="task-type-filter-select"
                />

                <UserFilterSelect
                    users={users}
                    value={userFilter}
                    onChange={onUserFilterChange}
                    placeholder="All Users"
                    allValue="All Users"
                    className="user-filter-select"
                />

                <StatusFilter
                    selectedStatuses={statusFilter}
                    onStatusChange={onStatusFilterChange}
                    onReset={handleStatusReset}
                    onApply={handleStatusApply}
                />

                <div className="trainings-filter-search">
                    <Search
                        size="medium"
                        placeholder="Search"
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        showClearButton={!!searchTerm}
                        onClear={() => onSearchChange('')}
                    />
                </div>
            </div>
        </div>
    );
};

export default TrainingsFilterBar;
